import {NavLink} from "react-router-dom";
import {useAuth} from "../context/AuthContext";

const navItems = [
    {to: "/dashboard", icon: "bi-grid-1x2", label: "Dashboard"},
    {to: "/notes", icon: "bi-journal-text", label: "Notes"},
    {to: "/bookmarks", icon: "bi-bookmark", label: "Bookmarks"},
    {to: "/todo", icon: "bi-check2-square", label: "Todo"},
    {to: "/project-log", icon: "bi-kanban", label: "Project Log"},
    {to: "/storage", icon: "bi-folder", label: "Storage"},
];

export default function Sidebar({ open, onClose }) {
    const {isAdmin} = useAuth();
    return (
        <aside className={`sidebar-wrapper${open ? " sidebar-open" : ""}`}>
            <div className="sidebar-brand-row">
                <a href="/dashboard" className="sidebar-brand d-flex align-items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="28" height="28" style={{flexShrink: 0, borderRadius: 6}}>
                        <defs>
                            <linearGradient id="sg" x1="0" y1="0" x2="1" y2="1">
                                <stop offset="0%" stopColor="#6366f1"/>
                                <stop offset="100%" stopColor="#8b5cf6"/>
                            </linearGradient>
                        </defs>
                        <rect width="512" height="512" rx="108" fill="url(#sg)"/>
                        <path fillRule="evenodd" fill="white"
                            d="M 110,100 L 195,100 A 215,156 0 0 1 195,412 L 110,412 Z M 165,158 L 195,158 A 145,98 0 0 1 195,354 L 165,354 Z"/>
                    </svg>
                    Danova
                </a>
                <button
                    className="sidebar-close d-md-none"
                    onClick={onClose}
                    aria-label="Close menu"
                >
                    <i className="bi bi-x" />
                </button>
            </div>
            <nav className="sidebar-section sidebar-nav nav flex-column flex-grow-1">
                <span className="sidebar-label">Menu</span>
                {navItems.map(({to, icon, label}) => (
                    <NavLink key={to} to={to} className={({isActive}) => `nav-link${isActive ? " active" : ""}`}>
                        <i className={`bi ${icon}`} />
                        {label}
                    </NavLink>
                ))}
            </nav>
            <nav className="sidebar-nav nav flex-column pb-3">
                <span className="sidebar-label">Account</span>
                <NavLink to="/user" className={({isActive}) => `nav-link${isActive ? " active" : ""}`}>
                    <i className="bi bi-person-circle" />
                    Profile
                </NavLink>
                {isAdmin && (
                    <NavLink to="/admin" className={({isActive}) => `nav-link${isActive ? " active" : ""}`}>
                        <i className="bi bi-shield-lock" />
                        Admin
                    </NavLink>
                )}
            </nav>
        </aside>
    );
}
